import {Accordion} from '@mantine/core';
import {Stack} from 'src/design/atoms/Stack';
import type {PropsWithChildren} from 'react';

export const SupportDetails = ({
  title,
  children,
}: PropsWithChildren<{title: string}>) => (
  <Accordion variant="contained">
    <Accordion.Item value="help">
      <Accordion.Control>{title}</Accordion.Control>
      <Accordion.Panel>
        <Stack gap="sm">{children}</Stack>
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);
